module.exports = __webpack_public_path__ + "img/home-outline.0632e37c.svg";